import React from "react";
import ControllerTraw from "./components/ControllerTraw";
import "./printcontroller.scss";
function PrintController({item,api,action}:any) {
  const CONTROL_LABELS: Record<string, string> = {
    dentisttext: "Staff Type",
    dentist: "Dentist Name",
  };
  const initialStateArray = Object.values(item || {})
    .filter((row: any) => row && typeof row === "object" && row.name)
    .map((row: any) => ({
      ...row,
      name: CONTROL_LABELS[row.title] || row.name,
    }));

  return (
   <div className="print_table">
     <table className="printcontroller">
      <thead>
        <tr>
          <th>name</th>
          <th>action</th>
          <th>position</th>
          <th>Size</th>
          <th>is show</th>
        </tr>
      </thead>
      <tbody>
        {initialStateArray.map((row: any, index: number) => (
          <ControllerTraw target={row} key={row.title || row.name || index} api={api} action={action} />
        ))}
      </tbody>
    </table>
   </div>
  );
}

export default PrintController;
